// In progess
import { createModuleStore } from '../utils'
export const useBroadcastMessagesStore = createModuleStore(
  'broadcast-messages',
  {
    type: 'Broadcast Message',
    pageHeading: 'Broadcast Messages',
    noHistory: true,
    sortingOn: 'toolbar',
    statusesFilterName: 'statuses',
    uploadOptionsCsv: '',
    uri: '/broadcast-messages',
    serviceUri: '/broadcast-messages',
    listingModuleName: 'Config',
    listingActivityName: 'View Broadcast Message',
    formModuleName: 'Config',
    formActivityName: 'Edit Broadcast Message',
    allFields: [
      {
        key: 'message',
        title: 'MESSAGE',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'type',
        title: 'TYPE',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'startTimestamp',
        title: 'START TIME',
        visible: true,
        sortable: true,
        disabled: false,
        type: 'datetime',
      },
      {
        key: 'endTimestamp',
        title: 'END TIME',
        visible: true,
        sortable: true,
        disabled: false,
        type: 'datetime',
      },
      {
        key: 'durationMillis',
        title: 'DURATION (SECONDS)',
        visible: true,
        sortable: true,
        disabled: false,
        type: 'millisToSecond',
      },
      {
        key: 'roles',
        title: 'ROLES',
        visible: true,
        sortable: true,
        disabled: false,
        type: 'broadcastRoles',
      },
      {
        key: 'actions',
        title: 'ACTIONS',
        visible: true,
        disabled: true,
        sortable: false,
      },
    ],
  },
  {},
  {
    resetPageFilters() {
      const store = useBroadcastMessagesStore()
      store.resetBaseFilters()
    },
    copy(item) {
      const obj = {
        type: item.type,
        roles: item.roles,
        startTimestamp: item.startTimestamp,
        endTimestamp: item.endTimestamp,
        message: item.message,
      }
      return obj
    },
  },
  {
    fields: [
      {
        id: 'broadcast_roles',
        name: 'roles',
        label: 'Roles',
        size: 4,
        component: 'ArsSmartSelect',
        componentProps: {
          multiple: true,
          placeholder: 'Pick containing role',
          dxTableName: 'Roles',
          serviceUri: '/roles',
          optionsLabel: 'name',
          submitValueKey: 'name',
        },
        rules: [
          {
            required: false,
            type: 'array',
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'broadcast_type',
        name: 'type',
        label: 'Message Type',
        size: 6,
        component: 'NSelect',
        componentProps: {
          multiple: false,
          placeholder: 'Please select a suitable alert config strategy.',
          optionsData: [
            { value: 'SUCCESS', label: 'SUCCESS' },
            { value: 'WARNING', label: 'WARNING' },
            { value: 'INFO', label: 'INFO' },
            { value: 'ERROR', label: 'ERROR' },
          ],
          clearable: false,
        },
        rules: [
          {
            required: false,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'broadcast_start_date_time',
        name: 'startTimestamp',
        label: 'Start Date / Time',
        size: 6,
        component: 'ArsDateTime',
        componentProps: {},
        rules: [
          {
            required: true,
            trigger: ['blur'],
          },
        ],
      },
      {
        id: 'broadcast_end_date_time',
        name: 'endTimestamp',
        label: 'End Date / Time',
        size: 6,
        component: 'ArsDateTime',
        componentProps: {},
        rules: [
          {
            required: false,
            trigger: ['blur'],
          },
        ],
      },
      {
        id: 'broadcast_duration_millis',
        name: 'durationMillis',
        label: 'Duration',
        size: 6,
        component: 'ArsTimeInput',
        defaultValue: 1000,
        componentProps: {
          submitAs: 'millis',
          showAs: 'seconds',
        },
        rules: [
          {
            required: false,
            type: 'number',
            trigger: ['blur', 'input'],
            customValidator: 'durationValidator',
          },
        ],
      },
      {
        id: 'broadcast_message',
        name: 'message',
        label: 'Message',
        size: 24,
        component: 'NInput',
        componentProps: {
          placeholder: 'Enter message',
        },
        rules: [
          {
            required: false,
            trigger: ['blur', 'input'],
          },
        ],
      },
    ],
  }
)
